<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yr/aban.png" alt="">
        </div>
        <div class="main ">
            <div class="bb">
                <img class="i1" src="../assets/tt.png" alt="">
            </div>
            <img class="sBig" src="../assets/yr/light.png" alt="">
            <p class="a">
                {{$t('home').text3}}
            </p>
            <p class="b">
                {{$t('home').text7}}
            </p>
            <div class="two wow fadeInUp">
                <img src="../assets/yr/right.png" alt="">
            </div>
            <div class="content wow fadeInUp" v-html="info.CONTENT">

            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import {getContent} from "../util/lang";

    export default {
        name: "about",
        data(){
            return{
                info:{
                    CONTENT:''
                }
            }
        },
        components:{
            footComponent
        },
        mounted(){
            if(this.$i18n.locale==='en') {
                this.getBai('54')
            }else{
                this.getBai('51')
            }
        },
        methods:{
            getBai(id){
                this.$nextTick(()=>{
                    const url = `${getContent(id)}`
                    this.$axios.get(url).then(res => {
                        this.info=res.data
                        console.log(this.info)
                    })
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    animation: down 2s linear;
    @keyframes down {
        from{
            transform: translateX(-30px);
        }
        to{
            transform: translateX(0);
        }
    }
    .banner{
        width:100%;
        overflow: hidden;
        img{
            width:100%;
            object-fit: cover;
            display: block;
            animation: big 1s linear forwards;
        }
        @keyframes big {
            from{
                transform: scale(1.1);
            }
            to{
                transform: scale(1);
            }
        }
    }
    .main{
        width:1280px;
        margin: 0 auto;
        p:nth-child(1){
            font-size: 65px;
            font-family: Calibri;
            margin-block-end: 0;
        }
        p:nth-child(2){
            color:#F4A000;
            font-size: 45px;
            font-style: italic;
            font-family: Calibri;
            margin-block-start: 0;
            text-indent: 10%;
            font-weight: bold;
            margin-block-end: 10px;
        }
        .a{
            width:62%;
            margin-left: 38%;
            font-family: Calibri;
            font-weight: lighter;
            line-height: 30px;
            margin-block-start:0;
        }
        .b{
            width:100%;
            font-family:Calibri;
            font-weight: lighter;
            line-height: 30px;
        }
        .bb{
            margin-top:60px;
        }
        .sBig{
            margin-left: 14%;
        }
        .two{
            width:100%;
            margin: 60px 0;
            overflow: hidden;
            margin-bottom: 0;
            img{
                display: block;
                width:100%;
                cursor: pointer;
                transition: .6s;
            }
            img:hover{
                transform: scale(1.05);
            }
        }
        .content{
            width:100%;
            line-height: 30px;
            font-size: 14px;
            margin: 30px auto;
        }
    }
    @media screen and (max-width:450px){
        .banner{
            height:300px;
            img{
                height:100%;
            }
        }
        .main{
            width:95%;
            .a{
                width:100%;
                margin-left: 0;
            }
            .bb{
                img{
                    width:100%;
                    object-fit:cover;
                }
            }
            .two{
                flex-direction: column;
                margin: 40px auto;
                img{
                    width:100%;
                    object-fit: cover;
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>